<div class="fullPageIframe" *ngIf="this._UserHelper?.isSignedIn" [ngStyle]="{ height: this._UiHelper.windowsHeight - 35 + 'px' }">
  <!--<iframe [ngStyle]="_style.iframeStyle" src="{{_URLFRAME}}"></iframe>-->
  <div id="golden-race-mobile-app" [ngStyle]="{ height: this._UiHelper.windowsHeight - 60 + 'px' }"></div>
</div>
<div class="" *ngIf="!this._UserHelper?.isSignedIn">
  <ng-container [ngSwitch]="['wettarena', 'b500', 'terminalPeru', 'cangobet'] | getProductName">
    <ng-container *ngSwitchCase="'wettarena'">
      <login-wettarena-component></login-wettarena-component>
    </ng-container>
    <ng-container *ngSwitchCase="'b500'">
      <login-b500-component></login-b500-component>
    </ng-container>
    <ng-container *ngSwitchCase="'cangobet'">
      <login-cangobet-component></login-cangobet-component>
    </ng-container>
    <ng-container *ngSwitchCase="'terminalPeru'">
      <login-terminalPeru-component></login-terminalPeru-component>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <login-b3000-component></login-b3000-component>
    </ng-container>
  </ng-container>
</div>
